// Satu-satunya penampil dialog aplikasi (lib/dialogAplikasi.js) — dipasang sekali di App.js.
import React from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogFooter, DialogTitle, DialogDescription,
} from "../ui/dialog";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { Input } from "../ui/input";
import { langganan, jawab } from "../../lib/dialogAplikasi";

export default function DialogAplikasi() {
  const [daftar, setDaftar] = React.useState([]);
  const [teks, setTeks] = React.useState("");
  React.useEffect(() => langganan(setDaftar), []);
  const p = daftar[0];
  React.useEffect(() => { setTeks(p?.jenis === "teks" ? String(p.awal ?? "") : ""); }, [p]);
  if (!p) return null;

  const kurang = p.jenis === "teks" && teks.trim().length < Math.max(1, p.minPanjang || 0);
  const batal = () => jawab(p.jenis === "konfirmasi" ? false : p.jenis === "teks" ? null : undefined);
  const setuju = () => {
    if (kurang) return;
    jawab(p.jenis === "konfirmasi" ? true : p.jenis === "teks" ? teks.trim() : undefined);
  };
  const Isian = p.multiBaris ? Textarea : Input;

  return (
    <Dialog open onOpenChange={(buka) => { if (!buka) batal(); }}>
      <DialogContent data-testid="dialog-aplikasi">
        <DialogHeader>
          <DialogTitle>{p.judul}</DialogTitle>
          <DialogDescription className="whitespace-pre-line">{p.pesan}</DialogDescription>
        </DialogHeader>
        {p.jenis === "teks" && (
          <div className="space-y-1">
            <Isian autoFocus value={teks} onChange={(e) => setTeks(e.target.value)} data-testid="dialog-aplikasi-isian"
                   onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey && !p.multiBaris) { e.preventDefault(); setuju(); } }} />
            {p.minPanjang > 1 && (
              <p className="text-xs text-muted-foreground">Minimal {p.minPanjang} karakter ({teks.trim().length} sekarang).</p>
            )}
          </div>
        )}
        <DialogFooter>
          {p.jenis !== "info" && (
            <Button variant="outline" onClick={batal} data-testid="dialog-aplikasi-batal">Batal</Button>
          )}
          <Button onClick={setuju} disabled={kurang} variant={p.bahaya ? "destructive" : "default"}
                  data-testid="dialog-aplikasi-ya">{p.ya}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
